import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

export type ActivityType = 'REVIVED_LEADS' | 'INFLUENCED_LEADS' | 'ACTIVE_OUTREACH';

export interface ActivityResponse {
  data: Array<{
    _id: string;
    content:
    | string
    | {
      title?: string;
      sub_title?: string;
      text?: string;
    };
  }>;
  meta: {
    totalDocuments: number;
    totalPages: number;
    currentPage: number;
  };
}

class Activity {
  static ENDPOINT = 'api/v2/activities';

  static async getActivities(params: {
    activityType: ActivityType;
    skip?: number;
    limit?: number;
    dealer_id?: string;
    timeperiod?: string;
    startDate?: string;
    endDate?: string;
    mysql?: boolean;
  }): Promise<APIResponseType<ActivityResponse>> {
    try {
      const cleanParams = {
        ...params,
        skip: params.skip || 0,
        limit: params.limit || 10
      };

      const response = await apiService.get<APIResponseType<ActivityResponse>>(
        this.ENDPOINT,
        cleanParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default Activity; 